import type { Branded } from "@@/utilities/branded";
import { z } from "zod";

type Password = Branded<string, "Password">;
const passwordZodSchema = z
    .string()
    .min(12) as unknown as z.ZodSchema<Password>;

export { passwordZodSchema };
export type { Password };
